import React from 'react';
import { useTheme } from 'ThemeContext';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import { GlobalFontsStyles } from 'assets/Global.style';
import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

library.add(far, fas, fab);

function FontAwesome() {
  const GlobalFonts = () => {
    const theme = useTheme();
    return <GlobalFontsStyles theme={theme.fontface} />;
  };
  return <GlobalFonts />;
}

export default FontAwesome;
